import { NewsSlider } from "@/features/app/news-slider/ui/NewsSlider";
import Link from "next/link";
import React from "react";

export function News() {
  return (
    <div className="w-full flex flex-col md-20 md:mb-40">
      <div className="md:w-full md:max-w-7xl md:mx-auto px-0 md:px-5 xl:px-0">
        <NewsSlider />
      </div>
    </div>
  );
}
